/**
 * Global JavaScript for C Plus Theme
 */

class CartDrawer {
  constructor() {
    this.drawer = document.querySelector('#cart-drawer');
    this.openButtons = document.querySelectorAll('[data-cart-drawer-open]');
    this.closeButtons = document.querySelectorAll('[data-cart-drawer-close]');

    this.init();
  }

  init() {
    this.openButtons.forEach(button => {
      button.addEventListener('click', () => this.open());
    });

    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close());
    });

    // Close on overlay click
    if (this.drawer) {
      this.drawer.addEventListener('click', (e) => {
        if (e.target === this.drawer) {
          this.close();
        }
      });
    }

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer?.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    this.drawer?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer?.classList.remove('active');
    document.body.style.overflow = '';
  }
}

class MobileMenu {
  constructor() {
    this.menuButton = document.querySelector('.header__mobile-menu');
    this.init();
  }

  init() {
    if (this.menuButton) {
      this.menuButton.addEventListener('click', () => {
        // Toggle mobile menu
        console.log('Mobile menu clicked');
      });
    }
  }
}

// Utility Functions
const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

const fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
};

// Initialize when DOM is ready
if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}

function init() {
  new CartDrawer();
  new MobileMenu();
}

// Export for use in other scripts
window.CPlusTheme = {
  debounce,
  fetchConfig
};
